import React from "react";
import { Icon } from "antd";
import store from "../reducers/";
import { path } from "ramda";
import I18n from "../i18n";

export default {
	buildColumnsEmployees: ({ category_title, onEdit, onDelete, onSeeHistory, onManageAttrbiute, choice }) => {
		let columns = [
			{
				title: I18n.t("email"),
				dataIndex: "email",
				sorter: true,
			}
		];

		let arrayContainAttr = [];
		Object.keys(category_title).map((key, index) => {
			arrayContainAttr.push(category_title[key] ? true : false);
			if (category_title[key]) {
				const dataIndex = `category${index + 1}`;
				return columns.push({
					title: <div style={{ display: "inline" }}>
						{category_title[key]}
						<Icon style={{ marginLeft: 8, cursor: "pointer" }}
							type="edit"
							onClick={() => onManageAttrbiute(index + 1, choice[`choice${index + 1}`].data)} />
					</div>,
					dataIndex,
					render: (text, record) => {
						const record_name = path([`category${index + 1}`, "data", "name"], record);
						return <div>{record_name || ""}</div>;
					},
					sorter: true,
					// sorter: (a, b) => {
					//     if (a[dataIndex]) {
					//         const aData = path(['data', 'name'], a[dataIndex])
					//         const bData = path(['data', 'name'], b[dataIndex])
					//         return b[dataIndex] ? aData.localeCompare(bData) : -1;
					//     } else if (b[dataIndex]) {
					//         const aData = path(['data', 'name'], a[dataIndex])
					//         const bData = path(['data', 'name'], b[dataIndex])
					//         return a[dataIndex] ? bData.localeCompare(aData) : 1;
					//     }
					// }
				});
			} else return null;
		});

		if (arrayContainAttr.some(attr => attr === false)) {
			const { color } = store.getState().organization.organization;
			columns.push({
				title: <div style={{ cursor: "pointer", textAlign: "center" }} onClick={() => onManageAttrbiute(null)}>
					<Icon type="plus-circle" style={{ color, marginRight: 5 }} />
					{I18n.t("create_new_attribute")}
				</div>,
				key: "add-attr",
				render: () => <div />,
			});
		}

		columns.push({
			title: "History" , key: "action-history", width: 90,
			render: (text, record) => (
				<span style={{ cursor: "pointer" }}>
					<Icon type="eye" onClick={() => onSeeHistory({ user: record })} />
				</span>
			),
		});

		columns.push({
			title: I18n.t("delete"), key: "action-delete", width: 90,
			render: (text, record) => (
				<span style={{ cursor: "pointer" }}>
					<Icon type="delete" onClick={() => onDelete({ user: record })} />
				</span>
			),
		});
		columns.push({
			title: I18n.t("edit"), key: "action-edit", width: 90,
			render: (text, record) => (
				<span style={{ cursor: "pointer" }}>
					<Icon type="edit"
						onClick={() => onEdit({ user: record })} />
				</span>
			),
		});
		return columns;
	},
	buildColumnsOverviewEmployees: ({ category_title }) => {
		let columns = [
			{
				title: I18n.t("pin"),
				dataIndex: "support_pin",
				// sorter: true,
				render: (text) => `#${text}`
			}
		];

		Object.keys(category_title).map((key, index) => {
			if (category_title[key]) {
				const dataIndex = `category${index + 1}`;
				return columns.push({
					title: category_title[key],
					dataIndex,
					render: (text, record) => {
						const record_name = path([`category${index + 1}`, "data", "name"], record);
						return <div>{record_name || ""}</div>;
					},
					// sorter: true,
					// sorter: (a, b) => {
					//     if (a[dataIndex]) {
					//         const aData = path(['data', 'name'], a[dataIndex])
					//         const bData = path(['data', 'name'], b[dataIndex])
					//         return b[dataIndex] ? aData.localeCompare(bData) : -1;
					//     } else if (b[dataIndex]) {
					//         const aData = path(['data', 'name'], a[dataIndex])
					//         const bData = path(['data', 'name'], b[dataIndex])
					//         return a[dataIndex] ? bData.localeCompare(aData) : 1;
					//     }
					// }
				});
			} else return null;
		});

		columns.push(
			{
				title: I18n.t("test_session"),
				dataIndex: "count_stress_tests",
				// sorter: true,
			},
			{
				title: I18n.t("counseling_session"),
				dataIndex: "count_appointments",
				// sorter: true,
			}
		);

		return columns;
	}
};


// WEBPACK FOOTER //
// ./src/util/employees.js